import React, { useMemo } from "react";
import { useQuery } from "@apollo/client";
import { Select } from "antd";

import { GET_STANDS_BLOCKS } from "graphql/query/stand-gql";

import { Icons } from "components/layout";
import { Localize } from "components/service";
import { useMe } from "components/use-hooks";

const { Option } = Select;

const CollectGraphicsBlockSelectField = ({ ...props }) => {
    const { me } = useMe();
    const { data, loading } = useQuery(GET_STANDS_BLOCKS, {
        variables: {
            where: {
                column: "EE_ID",
                operator: "EQ",
                value: me.eeCurrentId
            },
            whereCrafts: {
                column: "TYPE",
                operator: "EQ",
                value: "collect_graphics"
            },
            orderBy: [
                {
                    column: "BLOCK",
                    order: "ASC"
                }
            ],
            first: 500
        },
        fetchPolicy: "cache-first"
    });

    const {
        stands: {
            data: stands = []
        } = {}
    } = data || {};

    const blockOptions = useMemo(() => {
        return [...new Set(
            stands
                .map(({ block }) => block && block.trim())
                .filter(Boolean)
        )];
    }, [stands]);

    return (
        <Select
            className="collect-graphics-block-select-field"
            suffixIcon={<Icons.Arrow type="filled" />}
            loading={loading}
            defaultValue={null}
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
                String(option?.children || "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
            }
            { ...props }
        >
            <Option value={null}>
                <Localize>FORMS.Select_DefaultValue_All</Localize>
            </Option>
            {blockOptions.map((block) => (
                <Option key={block} value={block}>
                    {block}
                </Option>
            ))}
        </Select>
    );
};

export default CollectGraphicsBlockSelectField;
